// eslint-disable-next-line import/newline-after-import
import Users from './Users.vue';
export default Users;
